
import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';

@Component
export default class Recharge extends Vue {
  private bankSelected = this.bankAccounts.find(x => x.account_number === '2608202293');
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get configuration() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
  }
  get bankAccounts()  {
    if (this.configuration && this.configuration.BankAccounts) {
        return JSON.parse(this.configuration.BankAccounts);
    }
    return [ 
      // { "bank_name": "Ngân hàng Vietcombank", "account_name": "NGUYỄN THỊ HỒNG PHƯƠNG", "account_number": "1014524636", "branch": "HÀ THÀNH" },
      { "bank_name": "TECHCOMBANK", "account_name": "TRAN DUC HIEU", "account_number": "2608202293", "branch": "HÀ NỘI" }
      // { "bank_name": "Ngân hàng ACB", "account_name": "TRẦN ĐỨC HIẾU", "account_number": "17778897", "branch": "HÀ NỘI" }
    ];
  }
  get qrLink() {
      return `https://api.vietqr.io/image/${this.bankSelected.bank_name}-${this.bankSelected.account_number}-X1lAHCn.jpg?addInfo=XINGYUN${this.userInfo.userId}&accountName=${this.bankSelected.account_name}`;
  }
  private async getConfiguration() {
    const result = await commonService.configuration();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
    }
  }
  private async created() {
    if (!this.configuration) {
      await this.getConfiguration();
    }
  }
}
